/* Keep the native theme toggle; only synchronize menu geometry and widget visibility. */
(function () {
  function init() {
    var menu = document.querySelector('#mobile-menu.lux-dark-menu');
    if (!menu || menu.dataset.luxFitReady) return;
    menu.dataset.luxFitReady = 'true';
    var header = menu.closest('header');
    var frame;
    function fit() {
      var open = menu.getAttribute('aria-hidden') === 'false';
      document.documentElement.classList.toggle('lux-navigation-open', open);
      if (!open || !header) return;
      var parent = menu.offsetParent;
      if (!parent) return;
      var origin = parent.getBoundingClientRect();
      var bottom = header.getBoundingClientRect().bottom;
      var logo = header.querySelector('.header__logo');
      if (logo) bottom = Math.max(bottom, logo.getBoundingClientRect().bottom);
      var viewport = window.visualViewport;
      var viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
      menu.style.setProperty('--lux-menu-left', (-origin.left - parent.clientLeft) + 'px');
      menu.style.setProperty('--lux-menu-top', (bottom - origin.top - parent.clientTop + parent.scrollTop) + 'px');
      menu.style.setProperty('--lux-menu-height', Math.max(0, viewportBottom - bottom) + 'px');
    }
    function schedule() { cancelAnimationFrame(frame); frame = requestAnimationFrame(fit); }
    var observer = new MutationObserver(fit);
    observer.observe(menu, {attributes:true, attributeFilter:['aria-hidden']});
    window.addEventListener('resize', schedule);
    window.addEventListener('scroll', schedule, {passive:true});
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', schedule);
      window.visualViewport.addEventListener('scroll', schedule);
    }
    var resizeObserver = window.ResizeObserver ? new ResizeObserver(schedule) : null;
    if (resizeObserver && header) resizeObserver.observe(header);
    document.addEventListener('shopify:section:unload', function unload(event) {
      if (!event.target.contains(menu)) return;
      observer.disconnect();
      if (resizeObserver) resizeObserver.disconnect();
      cancelAnimationFrame(frame);
      window.removeEventListener('resize', schedule);
      window.removeEventListener('scroll', schedule);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', schedule);
        window.visualViewport.removeEventListener('scroll', schedule);
      }
      document.documentElement.classList.remove('lux-navigation-open');
      document.removeEventListener('shopify:section:unload', unload);
    });
    fit();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
